import React from 'react';
import TechServiceCard from '../Components/TechServiceCard';

const PartnersSection = () => {

  const logos = [
    { name: "Mint Ventures", src: "/partner/minit_ventures_company.svg", alt: "Mint Ventures – Trusted partner of Techxplore for enterprise application development and technology solutions." },
    { name: "Northrop", src: "/partner/north_company.svg", alt: "CODELAB Technologies – Trusted partner of Techxplore for enterprise application development and technology solutions." },
    { name: "Fixie", src: "/partner/fixie_company.svg", alt: "DgCrux Technology – Innovation partner with Techxplore, specializing in scalable tech architecture and consulting." },
    { name: "Finethix", src: "/partner/finethix_company.svg", alt: "CODELAB Technologies – Trusted partner of Techxplore for enterprise application development and technology solutions." },
    { name: "Invest Karo", src: "/partner/invent_karo_company.svg", alt: "CODELAB Technologies – Trusted partner of Techxplore for enterprise application development and technology solutions." },
    { name: "DgCrux", src: "/partner/dg_crux_company.svg", alt: "DgCrux Technology – Innovation partner with Techxplore, specializing in scalable tech architecture and consulting." },
    { name: "Codelab", src: "/partner/code_lab_company.svg", alt: "CODELAB Technologies – Trusted partner of Techxplore for enterprise application development and technology solutions." },
    
  ];

  return (
    <section className="bg-bgDefault text-white px-4 py-12 lg:py-24 lg:px-12 overflow-hidden ">
      <div className="container xl:mx-auto xl:max-w-screen-xl ">
        {/* Heading */}
        <h2 className="font-dmsans font-bold text-[32px] leading-[38px] tracking-[-6%] lg:text-heading-2 lg:tracking-[-0.06em]">
          Our Esteemed{' '}<span className="font-normal italic font-crimsonpro text-[#00E599]">Clients</span>
        </h2>

        {/* Scrolling Logos Container */}
        <div className="relative mt-12">
          {/* Scrolling wrapper */}
          <div className="flex animate-scroll-continuous">
            {/* First set of logos */}
            {logos.map((logo, index) => (
              <div key={`first-${index}`} className="flex-shrink-0 mx-3">
                <div className="lg:py-3 lg:px-6 flex flex-col justify-center items-center text-center bg-[#242424] border border-transparent transition-all duration-300 rounded-lg">
                  <div className="flex items-center justify-center">
                    <img src={logo.src} alt={logo.name} className="" />
                  </div>
                </div>
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {logos.map((logo, index) => (
              <div key={`second-${index}`} className="flex-shrink-0 mx-3">
                <div className=" lg:py-3 lg:px-6 flex flex-col justify-center items-center text-center bg-[#242424] border border-transparent transition-all duration-300 rounded-lg">
                  <div className="flex items-center justify-center">
                    <img src={logo.src} alt={logo.name} className="" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll-continuous {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll-continuous {
          animation: scroll-continuous 10s linear infinite;
        }

        .animate-scroll-continuous:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default PartnersSection;
